var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2499,
    height: 1028,
    viewBox: "0 0 2499 1028",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1003.68 456.234C1005.41 507.725 974.062 553.019 927.128 571.064L1014.53 729.638H927.037L845.106 582H768.553V729.638H692V325H877.915C894.827 325.235 911.524 328.83 927.035 335.576C942.545 342.322 956.559 352.085 968.262 364.297C979.965 376.509 989.123 390.926 995.204 406.709C1001.28 422.492 1004.17 439.327 1003.68 456.234ZM912.374 410.839C900.237 398.702 884.03 391.497 866.888 390.617H768.554V516.474H866.888C883.522 517 899.703 511.005 911.979 499.768C924.255 488.531 931.654 472.941 932.596 456.325C931.717 439.183 924.511 422.976 912.374 410.839Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M447.851 369.085C494.512 370.634 537.801 405.904 546.277 445.638L622.83 423.766C602.416 344.57 532.06 300.461 447.851 298C322.632 300.461 252.185 395.241 251 516.723C252.185 635.472 322.632 730.252 447.851 729.979C536.89 730.252 601.687 680.948 622.83 598.745L546.277 582.34C540.637 604.184 527.92 623.543 510.112 637.393C492.305 651.244 470.41 658.804 447.851 658.894C368.655 657.253 328.191 585.439 327.462 516.723C328.191 445.274 368.655 370.634 447.851 369.085ZM1486.79 713.574V308.936H1563.34L1732.76 576.872V308.936H1814.87V713.574H1732.76L1563.34 451.106V713.574H1486.79ZM2246.85 647.957V713.574H1956.95V308.936H2246.85V374.553H2033.6V467.511H2186.7V533.128H2033.6V647.957H2246.85ZM1131.36 713.574H1043.87L1175.11 308.936H1284.38L1415.7 713.574H1333.68L1311.81 647.957H1153.23L1131.36 713.574ZM1284.38 582.34H1175.11L1229.79 407.361L1284.38 582.34Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2498.91 0H0V1028H2498.91V0ZM2432 49H66V980H2432V49Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrane);
export default __webpack_public_path__ + "static/media/crane.2c8e574168d3d04a44339a6c36b4f342.svg";
export { ForwardRef as ReactComponent };